var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ToggleTableCells',{attrs:{"table-headers":_vm.tableHeaders,"cells":_vm.cells},on:{"setCells":_vm.setCells}})}
var staticRenderFns = []

export { render, staticRenderFns }